import { styled } from "@mui/system"
import { Box } from "@mui/material"

export const DataGridWrapper = styled(Box)({
  height: 400,
  width: "100%",
  backgroundColor: "var(--white)",
  flex: 1,
})

export const DraggedColumn = styled(Box)({
  pointerEvents: "none",
  userSelect: "none",
  position: "fixed",
  backgroundColor: "#fff",
  borderWidth: 0.5,
  borderStyle: "solid",
  borderColor: "#ccc",
  borderRadius: 2,
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
  fontSize: 14,
  fontWeight: 500,
  padding: "8px 12px",
  transform: "translate(-5%, -5%)",
  zIndex: 1000,
})

export const PickupBox = styled(Box)({
  cursor: "move",
  textOverflow: "ellipsis",
  fontWeight: 500,
})

export const DropLine = styled(Box)({
  position: "absolute",
  top: 0,
  left: 0,
  bottom: 0,
  width: "3px",
  background: "linear-gradient(to bottom, rgba(104, 181, 200, 0.8), rgba(35, 154, 152, 0.8))"
})

export const PickupDropContainer = styled(Box)({})
